import { getExtenSionListFetch, sendFileFetch } from "../../api/api";
import { uploadNewFiles } from "@/api/api.js";
// import { Notification } from 'element-ui';
const state = {
  extensionList: [],
  extensionHeader: [],
};

const actions = {
  async getExtenSionList({ commit }, { param, cb }) {
    try {
      const data = await getExtenSionListFetch({ data: JSON.stringify(param) });
      cb(data);
      // [data.popuReps[0], data.popuReps[data.popuReps.length - 1]] = [data.popuReps[data.popuReps.length - 1], data.popuReps[0]];
      // [data.popuList[0], data.popuList[data.popuList.length - 1]] = [data.popuList[data.popuList.length - 1], data.popuList[0]];
      commit("setExtenSionList", data);
    } catch (e) {
      throw new Error(e);
    }
  },
  async sendFile({ commit }, { param, cb }) {
    try {
      const data = await sendFileFetch(param);
      cb(data.code);
      commit("");
    } catch (e) {
      throw new Error(e);
    }
  },

  async uploadFile({ commit }, { param, cb }) {
    try {
      const data = await uploadNewFiles(param);
      cb(data);
      commit("");
    } catch (e) {
      throw new Error(e);
    }
  },
};

const mutations = {
  setExtenSionList(state, data) {
    state.extensionList = data.popuList;
    state.extensionHeader = data.mediaSourceList;
  },
};
export default {
  state,
  actions,
  mutations,
};
